module.exports = __webpack_public_path__ + "img/fire-in-my-heart.09f3a21a.png";